import React from "react"
import styled from "styled-components"
import {
  AvardaShippingBrokerShipping,
  OrderShippingAvardaShippingBroker
} from "lib/types/generated/graphql-types"
import { ReactComponent as IngridLogo } from "images/providers/ingrid-logo.svg"
import CopyButton from "components/Ui/CopyButton"
import ListEntry from "../../../../../components/Order/Ui/ListEntry"
import { Container, Row, Title } from "./Styled"

const CopyWrapper = styled.div`
  display: flex;

  svg {
    margin-top: 2.1rem;
  }
`

type Props = {
  shippingAvarda: OrderShippingAvardaShippingBroker
}

const AvardaShippingDetails = ({ shippingAvarda }: Props) => {
  const isAvardaShipping = (
    shipping: typeof shippingAvarda
  ): shipping is OrderShippingAvardaShippingBroker & {
    avardaShipping: AvardaShippingBrokerShipping
  } => shipping?.__typename === "OrderShippingAvardaShippingBroker" && "avardaShipping" in shipping

  const avardaData = isAvardaShipping(shippingAvarda) ? shippingAvarda.avardaShipping : undefined

  if (!avardaData?.ingrid) return null

  const ingridDelivery = avardaData?.ingrid

  return (
    <>
      <Title $logoMargin={"0 0.8rem 0"}>
        <IngridLogo /> details
      </Title>
      <Container>
        <Row>
          <ListEntry label={"Delivery type"} value={ingridDelivery?.deliveryType ?? "-"} />
          <CopyWrapper>
            <ListEntry label={"Transport ID"} value={ingridDelivery?.tosId} />
            <CopyButton string={ingridDelivery?.tosId} />
          </CopyWrapper>
        </Row>
        <Row>
          <ListEntry label={"Carrier"} value={ingridDelivery?.carrier ?? "-"} />
          <ListEntry label={"Carrier product ID"} value={ingridDelivery?.externalMethodId ?? "-"} />
        </Row>
        <Row>
          <ListEntry label={"Name"} value={ingridDelivery?.location?.address?.name ?? "-"} />
          <ListEntry
            label={"Address"}
            value={
              ingridDelivery?.location?.address?.addressLines
                ? ingridDelivery?.location?.address?.addressLines[0]
                : "-"
            }
          />
        </Row>
        <Row>
          <ListEntry label={"City"} value={ingridDelivery?.location?.address?.city ?? "-"} />
          <ListEntry
            label={"Postal code"}
            value={ingridDelivery?.location?.address?.postalCode ?? "-"}
          />
        </Row>
      </Container>
    </>
  )
}

export default AvardaShippingDetails
